var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentCheckboxAllChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 17,
    height: 17,
    stroke: "#B1B1B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8594 9.14059C16.0469 9.32804 16.0469 9.63196 15.8594 9.81941L11.3794 14.2994C11.192 14.4869 10.888 14.4869 10.7006 14.2994L8.14059 11.7394C7.95314 11.552 7.95314 11.248 8.14059 11.0606C8.32804 10.8731 8.63196 10.8731 8.81941 11.0606L11.04 13.2812L15.1806 9.14059C15.368 8.95314 15.672 8.95314 15.8594 9.14059Z",
    fill: "#612680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCheckboxAllChecked);
export default __webpack_public_path__ + "static/media/studentCheckboxAllChecked.3c8d934246508fb6ac47be9da8095374.svg";
export { ForwardRef as ReactComponent };